import APICaller from '@/shared/mixins/APICaller';
import forumApi from '@/features/forum/services/forumApi';
import { clearForumDrafts } from '@/features/forum-next/services/forumDrafts';

// Keep the current transport, including its authorization/CORS contract. The
// preview client adds X-Requested-With, which older cross-origin endpoints reject.
const currentClient = {
  get(url) {
    return new Promise((resolve, reject) => APICaller.methods._getAPICall(url,
      new APICaller.SuccessHandler(resolve),
      new APICaller.FailureHandler('317', 'No se pudo completar la operación de navegación.', reject),
      { loadingOverlay: false, displayErrors: false, logErrors: false }));
  }
};

export function unreadCurrentNotifications(payload, now = Date.now()) {
  return (Array.isArray(payload) ? payload : []).filter(item => Number(item.date) * 1000 <= now && String(item.status) === '0').length;
}

export class IncrementalNavigationRepository {
  constructor(client = currentClient, forumClient = forumApi) {
    this.client = client;
    this.forumClient = forumClient;
  }

  async getSettings() {
    // Fail closed independently: an unavailable setting must not hide unrelated links.
    const [referralsEnabled, newsflashPublicAccessEnabled] = await Promise.all([
      this.client.get('/api/v1/referrals/settings').then(({ data }) => data.status === 'success' && Boolean(data.enabled)).catch(() => false),
      this.client.get('/adminmenu/newsflash-public-access-setting').then(({ data }) => Boolean(data.success) && Number(data.value) === 1).catch(() => false)
    ]);
    return { referralsEnabled, newsflashPublicAccessEnabled };
  }

  async getName() {
    const { data } = await this.client.get('/api/v1/users/user/name');
    return String(data.name || '').trim();
  }

  async getUnreadCount(uid) {
    if (!Number(uid)) return 0;
    const { data } = await this.client.get(`/api/v1/eurekers-notifications/${encodeURIComponent(uid)}`);
    return unreadCurrentNotifications(data);
  }

  async markNotificationsRead(uid) {
    if (Number(uid)) await this.client.get(`/api/v1/eurekers-notifications/read-notifications/${encodeURIComponent(uid)}`);
  }

  async getForumUnreadCount() {
    const { data } = await this.forumClient.get('/forum/api/notifications');
    return Math.max(0, Number(data && data.unsilenced_count) || 0);
  }

  async logout() {
    await this.client.get('/api/v1/users/user/log-out');
    clearForumDrafts();
  }
}

export default new IncrementalNavigationRepository();
